/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Clients } from './clients';
import { Service } from './service';
import { ServiceProviders } from './serviceProviders';
import { ServiceRate } from './serviceRate';

export interface ServiceClientsDto { 
    services?: Service;
    serviceProvider?: ServiceProviders;
    client?: Clients;
    rate?: Array<ServiceRate>;
    userId?: string;
    applicationId?: string;
    applicationName?: string;
    email?: string;
}